/** Shared by the operator run panel and the portal takeover page. */

export const TAKEOVER_FRAME_MS = 800;

/** ~24s of blips: a rolling deploy or a laptop waking up must not end a sign-in. */
export const TAKEOVER_FRAME_FAILURES_ALLOWED = 30;

/** Tab and Escape go to the held page, so leaving the view needs its own combination. */
export const TAKEOVER_LEAVE_STAGE_KEY = 'Shift+Escape';

/** The keys both takeover surfaces offer as buttons. */
export const TAKEOVER_QUICK_KEYS = ['Enter', 'Tab', 'Escape'] as const;

/** The browser service renders every page at this viewport; clicks scale back to it. */
export const TAKEOVER_PAGE_VIEWPORT = { width: 1440, height: 900 };

/** The most text one relayed input may carry; matches the backend's limit. */
export const TAKEOVER_TEXT_MAX = 500;

/** Backoff for an unacknowledged input; after `tries` (~35s) it waits, still queued, for the next send. */
export const TAKEOVER_RETRY_MS = { first: 400, max: 4000, tries: 12 };

/** Non-printing keys worth relaying; anything else printable goes through as text. */
export const TAKEOVER_RELAYED_KEYS = new Set([
  'Backspace',
  'Delete',
  'Enter',
  'Tab',
  'Escape',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Home',
  'End',
]);
